module.exports = __webpack_public_path__ + "img/icon-delivery-truck-blue.9025537f.svg";